import React, { useEffect, useState } from "react";
import api from "../../api";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { Loader } from "./loader";
import "./SupportActivity.css";

function SupportRecentActivity({ adminType }) {
  const adminStore = useSelector((state) => state.adminReducer);
  const navigate = useNavigate();
  const [timeSpent, setTimeSpent] = useState({});
  const [messages, setMessages] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [loader, setLoader] = useState(true);
  const [inputData, setInputData] = useState({});
  const [supportMembers, setSupportMembers] = useState([]);

  const getTickets = async () => {
    try {
      const payload = { ...inputData };
      setLoader(true);
      const resp = await api.getSupportRecentActivity(payload);
      if (resp?.success) {
        setMessages(resp?.recentMessages || []);
        setSessions(resp?.recentSessions || []);
        setTickets(resp?.recentTickets || []);
        setTimeSpent(resp?.timeSpent || {});
      }
      setLoader(false);
    } catch (error) {
      console.error(error?.message);
      setLoader(false);
    }
  };

  const handleReset = () => {
    setInputData({});
    setMessages([]);
    setSessions([]);
    setTickets([]);
  };

  const getSupport = async () => {
    try {
      setLoader(true);
      const res = await api.getSupportAdmin();
      if (res?.success) {
        setSupportMembers(res.support);
      }
      setLoader(false);
    } catch (error) {
      console.error(error?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    getSupport();
  }, []);

  useEffect(() => {
    if (inputData?.adminId) {
      getTickets();
    }
  }, [inputData]);

  return (
    <div className="container-fluid payHistoryPage">
      <div className="row">
        <div className="col">
          {/* Header */}
          <div className="row mx-0 drivers-row">
            <div className="col-12 d-flex justify-content-between align-items-center">
              <h1 className="color-dark fs-17">Support Recent Activity</h1>
            </div>
          </div>

          {/* Filter Section */}
          <div className="SupportfilterM row mx-0">
            <div className="col-12">
              <div className="fRow">
                <div className="filter-label">Select Support:</div>
                <div className="form-group my-3 me-3 position-relative">
                  <i className="fa-solid fa-caret-down arrowDownIco" />
                  <select
                    name="support"
                    onChange={(e) =>
                      setInputData({
                        ...inputData,
                        adminId: e.target.value,
                      })
                    }
                    value={inputData?.adminId || ""}
                    className="form-control"
                  >
                    <option value="">Select Support</option>
                    {supportMembers.map((val, key) => (
                      <option key={key} value={val?._id}>
                        {val?.name}
                      </option>
                    ))}
                  </select>
                </div>
                <button className="themeBlackBtn" onClick={handleReset}>
                  Reset Filter
                </button>
              </div>
            </div>
          </div>

          {/* Analytics Boxes */}
          <div className="row analytics-row mt-3">
            <AnalyticsBox
              icon={<i className="fa-solid fa-clock"></i>}
              title="Spent Today"
              amount={timeSpent?.today || 0}
              unit="min"
            />
            <AnalyticsBox
              icon={<i className="fa-solid fa-clock"></i>}
              title="Spent last 7 Days"
              amount={timeSpent?.last7Days || 0}
              unit="min"
            />
            <AnalyticsBox
              icon={<i className="fa-solid fa-clock"></i>}
              title="Spent This Month"
              amount={timeSpent?.thisMonth || 0}
              unit="min"
            />
          </div>

          {/* Tables */}
          <TableSessions data={sessions} />
          <Table data={tickets} />
          <TableMessage data={messages} />
        </div>
      </div>
      {loader && <Loader />}
    </div>
  );
}

// Analytics Box Component
function AnalyticsBox({ icon, title, amount, unit }) {
  return (
    <div className="col-xl-4 col-md-6 mb-4">
      <div className="card h-100 py-2 border-transparent br-10 analytics-card">
        <div className="card-body">
          <div className="row no-gutters align-items-center">
            <div className="col">
              <div className="analytic-box-img">{icon}</div>
            </div>
            <div className="col-auto mr-2">
              <div className="text-xs font-weight-bold mb-1">
                <span className="analytics-box-title">{title}</span>
              </div>
              <div className="h3 mb-0 font-weight-bold text-gray-800">
                {amount} {unit && <span className="unit-text">{unit}</span>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Recent Sessions Table
const TableSessions = ({ data }) => {
  const formatDate = (date) => {
    return moment(date).format("MMMM Do YYYY, h:mm:ss a");
  };

  function formatMinutesToHours(minutes) {
    if (typeof minutes !== "number" || isNaN(minutes)) return "0 min";
    if (minutes < 60) return `${minutes} min`;
    
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    
    if (remainingMinutes === 0) {
      return `${hours} hr${hours > 1 ? "s" : ""}`;
    } else {
      return `${hours} hr${hours > 1 ? "s" : ""} ${remainingMinutes} min`;
    }
  }

  return (
    <div className="card sortby-box br-10 border-transparent mt-3">
      <div className="card-header br-10 bg-white border-transparent py-3">
        <h3>Recent Sessions</h3>
        <div className="table-responsive">
          <table className="table table-hover drivers-table">
            <thead>
              <tr>
                <th>Login Time</th>
                <th>Logout Time</th>
                <th>Duration</th>
                <th>Active</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-d db">
                        {formatDate(item?.loginTime)}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-d db">
                        {formatDate(item?.logoutTime)}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-d db">
                        {formatMinutesToHours(item?.duration)}
                      </div>
                    </td>
                    <td>
                      <div
                        className={
                          item?.active
                            ? "green table-text-dark w-max-d db"
                            : "red table-text-dark w-max-d db"
                        }
                      >
                        {item?.active ? "Online" : "Offline"}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center py-4 no-data-message">
                    No recent sessions found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

// Recent Ticket Process Table
const Table = ({ data }) => {
  const navigate = useNavigate();

  const formatDate = (date) => {
    return moment(date).format("MMMM Do YYYY, h:mm:ss a");
  };

  return (
    <div className="card sortby-box br-10 border-transparent mt-3">
      <div className="card-header br-10 bg-white border-transparent py-3">
        <h3>Recent Ticket Process</h3>
        <div className="table-responsive">
          <table className="table table-hover drivers-table">
            <thead>
              <tr>
                <th>Issue ID</th>
                <th>User Email</th>
                <th>Status</th>
                <th>Issue Type</th>
                <th>Updated At</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-d db">
                        {item?.issueId}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-d db">
                        {item?.userId?.email}
                      </div>
                    </td>
                    <td>
                      <div
                        className={
                          item?.status === "pending"
                            ? "red table-text-dark w-max-d db"
                            : item?.status === "processing"
                            ? "yellow table-text-dark w-max-d db"
                            : "green table-text-dark w-max-d db"
                        }
                      >
                        {item?.status}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-d db">
                        {item?.issueType}
                      </div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-d db">
                        {formatDate(item?.updatedAt)}
                      </span>
                    </td>
                    <td>
                      <i
                        className="fa-solid fa-eye cursor-pointer"
                        onClick={() =>
                          navigate(`/admin/support/ticket/${item?.issueId}`)
                        }
                      ></i>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-4 no-data-message">
                    No recent tickets found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

// Recent Message Sent Table
const TableMessage = ({ data }) => {
  const [activeImg, setActiveImg] = useState("");
  const [showMore, setShowMore] = useState(false);

  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);

  const formatDate = (date) => {
    return moment(date).format("MMMM Do YYYY, h:mm:ss a");
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10 bg-white border-transparent py-3">
          <h3>Recent Message Sent</h3>
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th>Issue Id</th>
                  <th>Issue Type</th>
                  <th>Message</th>
                  <th>Timestamp</th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((item, key) => (
                    <tr key={key}>
                      <td>
                        <div className="table-text-dark w-max-d db">
                          {item?.issueId}
                        </div>
                      </td>
                      <td>
                        <div className="table-text-dark w-max-d db">
                          {item?.issueType}
                        </div>
                      </td>
                      <td>
                        <div className="table-text-dark w-max-d db message-content">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item?.message,
                            }}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="table-text-dark w-max-d db">
                          {formatDate(item?.timestamp)}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center py-4 no-data-message">
                      No recent messages found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Modal size="lg" show={showMore} onHide={handleCloseMore} centered>
        <Modal.Body>
          <div className="otpModalMain broadcastModal">
            <div className="closeIcon" onClick={handleCloseMore}>
              <i className="fa-solid fa-xmark" />
            </div>
            <div className="showMoreModalM">
              <div className="showMoreModal">
                <img className="w-100" src={activeImg} alt="" />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SupportRecentActivity;